class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.listLinks = [...document.querySelectorAll('.list-menu > li > .header__menu-item:not(summary)')];
    this.body = document.querySelector('body');

    this.body.addEventListener('click', this.closeFromOuter);

    this.listLinks.map(item => item.addEventListener('mouseenter', this.closeFromOuter));
    this.mainDetailsToggle.addEventListener('mouseenter', this.open.bind(this));

    this.addEventListener('keyup', this.onKeyUp);
    this.mainDetailsToggle.addEventListener('focusout', this.closeFromOuter);
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details-disclosure details[open]');
    if (!openDetailsElement) return;

    const summaryElement = openDetailsElement.querySelector('summary');
    openDetailsElement.removeAttribute('open');
    summaryElement.focus();
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  open() {
    this.closeFromOuter();
    this.mainDetailsToggle.setAttribute('open', '')
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open')
  }
  
  closeFromOuter()
  {
    const openDetailsElement = document.querySelector('details[open]');
    if (openDetailsElement && openDetailsElement.parentElement.tagName.toLowerCase() != 'details-modal') 
    {
      if (!openDetailsElement.parentNode.classList.contains('collection__accordion')){
        openDetailsElement.removeAttribute('open');
      }
      if (openDetailsElement.classList?.contains('menu-opening')){
        document.querySelector('body').classList?.remove('overflow-hidden-tablet');
        openDetailsElement.classList?.remove('menu-opening');
        document.querySelector('header').classList.remove('menu-opening-header');
      }
    }
  }
}

customElements.define('details-disclosure', DetailsDisclosure);